/**
 * Dashboard - CountryInfo Store
 *
 * @since 2018-07-30
 * @author ms1124.kim
 *
 */
import JSONBigInt from 'json-bigint'
import {SystemApiPrefix as smApiPrefix} from 'utils'

// Prefix
const analysisApiPath = '/api/an/analysis'
const interfaceApiPath = `${smApiPrefix}/interfaces`
// TAMS
const interfaceIdApiPath = `/api/an/interfaces`

export const state = () => ({
  panelList: [],
  interfaces: [],
  selectedInterfaces: []
})

export const mutations = {
  /*
    이름: setInterfaces
    설명: 인터페이스 목록을 스토어에 저장한다.
  */
  setInterfaces (state, interfaces) {
    state.interfaces = interfaces
  },
  /*
    이름: setInitAnalysisData
    설명: 스토어의 데이터를 모두 초기화한다.
  */
  setInitAnalysisData (state) {
    state.panelList = []
    state.interfaces = []
    state.selectedInterfaces = []
  },
  /*
    이름: setSelectedInterfaces
    설명: 저장된 인터페이스를 스토어의 상태값에 저장한다.
  */
  setSelectedInterfaces (state, interfaces) {
    state.selectedInterfaces = interfaces
  }
}

export const actions = {
  /*
    이름: startAnalysisData
    설명: 분석 데이터 조회를 시작한다.
  */
  async startAnalysisData ({commit, state}, analysisParams) {
    let result = {
      code: 'ok',
      result: {}
    }

    try {
      result = await this.$axios.$post(`${analysisApiPath}/start`, analysisParams, {
        loading: false,
        successAlert: false
      })
    } catch (e) {
      result.code = 'nok'
      result.reason = e
    }

    return result
  },
  /*
    이름: getAnalysisStatus
    설명: 조회중인 분석 데이터의 상태를 가져온다.
  */
  async getAnalysisStatus ({commit, state}, {requestId}) {
    let result = {
      code: 'ok',
      result: {}
    }

    try {
      result = await this.$axios.$get(`${analysisApiPath}/${requestId}/status`, {
        loading: false,
        successAlert: false
      })
    } catch (e) {
      result.code = 'nok'
      result.reason = e
    }

    return result
  },
  /*
    이름: getAnalysisData
    설명: 분석이 중지 / 완료된 데이터를 가져온다.
  */
  async getAnalysisData ({commit, state}, {requestId}) {
    let result = {
      code: 'ok',
      result: {}
    }

    try {
      result = await this.$axios.$get(`${analysisApiPath}/${requestId}/result`, {
        loading: false,
        successAlert: false,
        transformResponse: [
          (data) => {
            return JSONBigInt.parse(data)
          }
        ]
      })
    } catch (e) {
      result.code = 'nok'
      result.reason = e
    }

    return result
  },
  /*
    이름: stopAnalysisData
    설명: 조회중인 작업을 중지하고 현재까지의 결과를 리턴한다.
  */
  async stopAnalysisData ({commit, state}, {requestId}) {
    let result = {
      code: 'ok',
      result: {}
    }

    try {
      result = await this.$axios.$delete(`${analysisApiPath}/${requestId}${'/stop'}`, {
        loading: false,
        successAlert: false,
        transformResponse: [
          (data) => {
            return JSONBigInt.parse(data)
          }
        ]
      })
    } catch (e) {
      result.code = 'nok'
      result.reason = e
    }

    return result
  },
  /*
    이름: endAnalysisData
    설명: 조회 작업이 완료되면 호출된다. 서버의 리소스를 해제하는 명령어이므로 반드시 호출한다.
  */
  async endAnalysisData ({commit, state}, {requestId}) {
    let result = {
      code: 'ok',
      result: {}
    }

    try {
      result = await this.$axios.$delete(`${analysisApiPath}/${requestId}${'/end'}`, {
        loading: false,
        successAlert: false
      })
    } catch (e) {
      result.code = 'nok'
      result.reason = e
    }

    return result
  },
  /*
    이름: getDeviceInterface
    설명: 장비의 물리 인터페이스 목록을 불러온다.
  */
  async getDeviceInterface ({state, commit}) {
    const res = {
      code: 'ok'
    }

    try {
      // 인터페이스 목록 불러오기
      const {code, result} = await this.$axios.$get(interfaceApiPath)

      if (code === 'ok') {
        const ethList = []

        for (const ethInfo of result) {
          const ethName = ethInfo.name

          ethList.push(ethName)
        }

        commit('setInterfaces', ethList)
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /*
    이름: getSelectedInterfaces
    설명: 마지막으로 선택한 인터페이스의 목록을 가져온다. (로컬 스토리지 구현 예정)
  */
  async getSelectedInterfaces ({commit}) {
    // API 호출
    commit('setSelectedInterfaces', ['eth0'])
  },
  /*
    이름: getDeviceInterface
    설명: 장비의 물리 인터페이스 목록을 불러온다. (TAMS)
  */
  async getDeviceInterfaceId ({state, commit}, machId) {
    try {
      const res = await this.$axios.$get(`${interfaceIdApiPath}/${machId}`)

      return res
    } catch (error) {
      return void 0
    }
  }
}
export const getters = {}
export const strict = false
